import { useEffect } from "react";

import { useLocation, useNavigate } from "@tanstack/react-router";

import { useAbility } from "@/utils/casl";
import { checkRoutePermission } from "@/utils/route-permission";

interface RoutePermissionGuardProps {
  children: React.ReactNode;
  fallbackRoute?: string;
}

export function RoutePermissionGuard({
  children,
  fallbackRoute = "/unauthorized",
}: RoutePermissionGuardProps) {
  const ability = useAbility();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const hasPermission = checkRoutePermission(ability, currentPath);

    if (!hasPermission) {
      navigate({ to: fallbackRoute });
    }
  }, [ability, location.pathname, navigate, fallbackRoute]);

  return <>{children}</>;
}
